<template>
  <div class="tw-max-h-full">
    <GraphqlDataTable
      :query
      :order-by="initialOrder"
      :filter-black-list="['accounts', 'externalIdentifiers']"
      :max-height-adjustment="30"
    >
      <template #action="{ row }">
        <HireActionColumn :row="row" />
      </template>
    </GraphqlDataTable>
  </div>
</template>

<script lang="ts" setup>
import { TypedQueryDocumentNode } from 'graphql/index'
import GraphqlDataTable from '@/components/GraphqlDataTable/GraphqlDataTable.vue'
import { graphql } from '@/gql'
import { HireOrderByColumn, SortOrder } from '@/gql/graphql'
import HireActionColumn from '@/components/GraphqlDataTable/columns/Hire/HireActionColumn.vue'

const query = graphql(`
  query HireContractsQuery(
    $accounts: [ID!]
    $search: String
    $page: Int!
    $first: Int!
    $orderBy: [HiresOrderByClauseInput!]
    $activeStatus: [HireActiveStatus!]
    $contractType: [ContractType!]
    $startDateRange: DateRangeInput
    $createdAtDateRange: DateRangeInput
    $hireOwners: [ID!]
    $workers: [ID!]
    $externalIdentifiers: [String!]
    $recruiterOwnershipIsExpired: Boolean
  ) {
    hires(
      accounts: $accounts
      search: $search
      page: $page
      first: $first
      orderBy: $orderBy
      recruiterOwnershipIsExpired: $recruiterOwnershipIsExpired
      startDateRange: $startDateRange
      createdAtDateRange: $createdAtDateRange
      contractType: $contractType
      activeStatus: $activeStatus
      workers: $workers
      externalIdentifiers: $externalIdentifiers
      owners: $hireOwners
      includeDeleted: true
    ) {
      paginatorInfo {
        ...PaginatorInfoFragment
      }
      data {
        ...HireCreatedColumn
        ...HireAvatarColumn

        ...HireTitleNavigationPoNumberColumn

        startDate
        endDate

        ...RateColumnHire

        ...HireHasStaffingAgencyColumn
        # Payment requests
        ...HirePaymentRequestColumn

        ...HireClassificationColumn

        ...HireContractPopoverColumn

        ...HireActionColumn
      }
    }
  }
`) as TypedQueryDocumentNode

const initialOrder = {
  field: HireOrderByColumn.StartDate,
  order: SortOrder.Desc,
}
</script>

<style scoped></style>
